import React, { useState, useContext } from "react";
import axios from "axios";
// import { useNavigate } from "react-router-dom";
import { FiUser, FiLock, FiArrowRight, FiShield} from "react-icons/fi";


import AuthContext from "../context/AuthContext";
import "./LoginPage.css";

const LoginPage = () => {
    // const navigate = useNavigate();
    const { setUser, setAdmin } = useContext(AuthContext);
    
    const [formData, setFormData] = useState({
        username: "",
        password: ""
    });
    const [status, setStatus] = useState({
        loading: false,
        message: "",
        type: "" // 'success', 'error', or ''
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Reset status
        setStatus({
            loading: true,
            message: "Authenticating...",
            type: "info"
        });

        try {
            const response = await axios.post(
                "/public/login_fallback_api.php",
                { username: formData.username, password: formData.password },
                {
                    headers: { "Content-Type": "application/json" },
                    withCredentials: true,   // ← add this
                    timeout: 6000
                }
            );

            console.log(response.data)

            if (response.data.success) {
                sessionStorage.removeItem('justLoggedOut');
                setStatus({
                    loading: false,
                    message: "Login successful! Redirecting...",
                    type: "success"
                });

                // Update auth context
                if (response.data.user) {
                    setUser(response.data.user);
                }
                if (response.data.admin) {
                    setAdmin(response.data.admin);
                }

                // Store session/token if provided
                if (response.data.token) {
                    localStorage.setItem("authToken", response.data.token);
                }

                // Redirect after brief delay to show success message
                setTimeout(() => {
                    window.location.href = process.env.PUBLIC_URL + '/';
                }, 2000);
            } else {
                setStatus({
                    loading: false,
                    message: response.data.message || "Login failed. Please check your credentials.",
                    type: "error"
                });
            }
        } catch (error) {
            let errorMessage = "An unexpected error occurred. Please try again.";
            
            if (error.response) {
                // Server responded with error status
                if (error.response.status === 401) {
                    errorMessage = "Invalid username or password.";
                } else if (error.response.status === 429) {
                    errorMessage = "Too many attempts. Please wait a moment.";
                } else if (error.response.data?.message) {
                    errorMessage = error.response.data.message;
                }
            } else if (error.request) {
                // Request made but no response
                errorMessage = "Unable to connect to server. Please check your connection.";
            }

            setStatus({
                loading: false,
                message: errorMessage,
                type: "error"
            });
        }
    };

    return (
        <React.Fragment>

            <div className="login-page">
                {/* Bento Grid Container */}
                <div className="bento-container">
                    
                    {/* Main Login Card - Large */}
                    <div className="bento-card bento-card--large bento-card--prussian">
                        <div className="bento-card__pattern pattern-dots"></div>
                        <div className="bento-card__content">
                            <div className="login-header">
                                <div className="login-icon">
                                    <FiShield />
                                </div>
                                <h1>LOGIN</h1>
                                <p>Secure access to your flight operations dashboard</p>
                            </div>
                            
                            <form onSubmit={handleSubmit} className="login-form">
                                <div className="input-group">
                                    <div className="input-wrapper">
                                        <FiUser className="input-icon" />
                                        <input
                                            type="text"
                                            name="username"
                                            value={formData.username}
                                            onChange={handleInputChange}
                                            placeholder="Username"
                                            disabled={status.loading}
                                            required
                                        />
                                    </div>
                                </div>
                                
                                <div className="input-group">
                                    <div className="input-wrapper">
                                        <FiLock className="input-icon" />
                                        <input
                                            type="password"
                                            name="password"
                                            value={formData.password}
                                            onChange={handleInputChange}
                                            placeholder="Password"
                                            disabled={status.loading}
                                            required
                                        />
                                    </div>
                                </div>
                                
                                {status.message && (
                                    <div className={`status-message status-message--${status.type}`}>
                                        {status.type === "loading" && <span className="spinner"></span>}
                                        {status.message}
                                    </div>
                                )}
                                
                                <button 
                                    type="submit" 
                                    className="login-button"
                                    disabled={status.loading}
                                >
                                    {status.loading ? "Signing In..." : "Sign In"}
                                    <FiArrowRight className="button-icon" />
                                </button>
                            </form>
                        </div>
                    </div>

                </div>
            </div>
        </React.Fragment>
    );
};

export default LoginPage;
